// The lesson's practice: the question sets under a lesson, answering them, and
// what a check says. "Amaliy topshiriq" is what the lesson page already calls
// a practice (learn.ts), so the two read as one. Shared words come from common.ts.

import { defineMessages, plural } from './index'

export default defineMessages(
  {
    title: 'Amaliy topshiriqlar',
    progress: '{n} tadan {passed} tasi bajarildi',
    requiredNote: 'Keyingi dars barcha topshiriqlarga to‘liq to‘g‘ri javob berganingizdan so‘ng ochiladi.',
    loadFailed: 'Topshiriqlarni yuklab bo‘lmadi.',

    number: '№{n}',
    practiceN: '{n}-topshiriq',
    kindMultiple: 'Bir nechta javob',
    kindSingle: 'Bitta javob',
    kindFill: 'Bo‘sh joyni to‘ldirish',
    kindSelect: 'Ro‘yxatdan tanlash',
    passedBadge: 'Bajarildi',

    questionN: '{n}-savol',
    howSingle: 'Bitta to‘g‘ri javobni tanlang.',
    howMultiple: 'Barcha to‘g‘ri javoblarni belgilang.',
    howFill: 'Bo‘sh joylarga kerakli so‘zni yozing.',
    howSelect: 'Har bir ro‘yxatdan to‘g‘ri variantni tanlang.',
    gapN: '{n}-bo‘sh joy',
    dropdownN: '{n}-ro‘yxat',
    choose: 'Tanlang',
    unanswered: 'Bu savolga hali javob berilmagan.',
    right: 'To‘g‘ri',
    wrong: 'Noto‘g‘ri',

    check: 'Tekshirish',
    checking: 'Tekshirilmoqda…',
    tryAgain: 'Qayta urinish',
    answerAll: 'Avval barcha savollarga javob bering: {n} ta savol javobsiz qoldi.',
    passedTitle: 'Barakalla! Topshiriq bajarildi.',
    failedTitle: 'Hali hammasi to‘g‘ri emas.',
    failedHint: 'Noto‘g‘ri deb belgilangan savollarni qayta ko‘rib chiqing va yana urinib ko‘ring.',
    score: '{total} tadan {correct} tasi to‘g‘ri · {pct}%',
    lastAttempt: 'Oxirgi urinish: {total} tadan {correct} tasi to‘g‘ri ({pct}%)',

    err_locked: 'Bu dars hali siz uchun ochilmagan.',
    err_not_found: 'Bu topshiriq endi mavjud emas. Sahifani yangilang.',
  },
  {
    en: {
      title: 'Practice',
      progress: (v, lang) =>
        plural(lang, Number(v.n), { one: '{passed} of {n} practice done', other: '{passed} of {n} practices done' }),
      requiredNote: 'The next lesson opens once you have answered every practice fully correctly.',
      loadFailed: 'The practice could not be loaded.',

      number: 'No. {n}',
      practiceN: 'Practice {n}',
      kindMultiple: 'Multiple choice',
      kindSingle: 'Single choice',
      kindFill: 'Gap filling',
      kindSelect: 'Select options',
      passedBadge: 'Done',

      questionN: 'Question {n}',
      howSingle: 'Choose the one correct answer.',
      howMultiple: 'Tick every correct answer.',
      howFill: 'Type the missing words into the gaps.',
      howSelect: 'Pick the right option in each list.',
      gapN: 'Gap {n}',
      dropdownN: 'List {n}',
      choose: 'Choose',
      unanswered: 'This question has not been answered yet.',
      right: 'Correct',
      wrong: 'Incorrect',

      check: 'Check',
      checking: 'Checking…',
      tryAgain: 'Try again',
      answerAll: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Answer every question first: {n} question is still unanswered.',
          other: 'Answer every question first: {n} questions are still unanswered.',
        }),
      passedTitle: 'Well done! Practice complete.',
      failedTitle: 'Not everything is correct yet.',
      failedHint: 'Look again at the questions marked incorrect and try once more.',
      score: '{correct} of {total} correct · {pct}%',
      lastAttempt: 'Last attempt: {correct} of {total} correct ({pct}%)',

      err_locked: 'This lesson isn’t open to you yet.',
      err_not_found: 'This practice no longer exists. Reload the page.',
    },
    ru: {
      title: 'Практические задания',
      progress: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Выполнено {passed} из {n} задания',
          few: 'Выполнено {passed} из {n} заданий',
          many: 'Выполнено {passed} из {n} заданий',
          other: 'Выполнено {passed} из {n} задания',
        }),
      requiredNote: 'Следующий урок откроется, когда вы полностью правильно выполните все задания.',
      loadFailed: 'Не удалось загрузить задания.',

      number: '№{n}',
      practiceN: 'Задание {n}',
      kindMultiple: 'Несколько ответов',
      kindSingle: 'Один ответ',
      kindFill: 'Заполнение пропусков',
      kindSelect: 'Выбор из списка',
      passedBadge: 'Выполнено',

      questionN: 'Вопрос {n}',
      howSingle: 'Выберите один правильный ответ.',
      howMultiple: 'Отметьте все правильные ответы.',
      howFill: 'Впишите в пропуски нужные слова.',
      howSelect: 'В каждом списке выберите правильный вариант.',
      gapN: 'Пропуск {n}',
      dropdownN: 'Список {n}',
      choose: 'Выберите',
      unanswered: 'На этот вопрос ещё нет ответа.',
      right: 'Верно',
      wrong: 'Неверно',

      check: 'Проверить',
      checking: 'Проверяем…',
      tryAgain: 'Попробовать снова',
      answerAll: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Сначала ответьте на все вопросы: без ответа остался {n} вопрос.',
          few: 'Сначала ответьте на все вопросы: без ответа осталось {n} вопроса.',
          many: 'Сначала ответьте на все вопросы: без ответа осталось {n} вопросов.',
          other: 'Сначала ответьте на все вопросы: без ответа осталось {n} вопроса.',
        }),
      passedTitle: 'Отлично! Задание выполнено.',
      failedTitle: 'Пока не всё верно.',
      failedHint: 'Посмотрите ещё раз на вопросы, отмеченные как неверные, и попробуйте снова.',
      score: 'Верно {correct} из {total} · {pct}%',
      lastAttempt: 'Последняя попытка: верно {correct} из {total} ({pct}%)',

      err_locked: 'Этот урок вам пока недоступен.',
      err_not_found: 'Этого задания больше нет. Обновите страницу.',
    },
    de: {
      title: 'Übungen',
      progress: (v, lang) =>
        plural(lang, Number(v.n), { one: '{passed} von {n} Übung erledigt', other: '{passed} von {n} Übungen erledigt' }),
      requiredNote: 'Die nächste Lektion öffnet sich, sobald Sie alle Übungen vollständig richtig gelöst haben.',
      loadFailed: 'Die Übungen konnten nicht geladen werden.',

      number: 'Nr. {n}',
      practiceN: 'Übung {n}',
      kindMultiple: 'Mehrfachauswahl',
      kindSingle: 'Einfachauswahl',
      kindFill: 'Lückentext',
      kindSelect: 'Auswahllisten',
      passedBadge: 'Erledigt',

      questionN: 'Frage {n}',
      howSingle: 'Wählen Sie die eine richtige Antwort.',
      howMultiple: 'Kreuzen Sie alle richtigen Antworten an.',
      howFill: 'Tragen Sie die fehlenden Wörter in die Lücken ein.',
      howSelect: 'Wählen Sie in jeder Liste die richtige Möglichkeit.',
      gapN: 'Lücke {n}',
      dropdownN: 'Liste {n}',
      choose: 'Auswählen',
      unanswered: 'Diese Frage ist noch nicht beantwortet.',
      right: 'Richtig',
      wrong: 'Falsch',

      check: 'Prüfen',
      checking: 'Wird geprüft…',
      tryAgain: 'Noch einmal versuchen',
      answerAll: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Beantworten Sie zuerst alle Fragen: {n} Frage ist noch offen.',
          other: 'Beantworten Sie zuerst alle Fragen: {n} Fragen sind noch offen.',
        }),
      passedTitle: 'Sehr gut! Übung erledigt.',
      failedTitle: 'Noch ist nicht alles richtig.',
      failedHint: 'Sehen Sie sich die als falsch markierten Fragen noch einmal an und versuchen Sie es erneut.',
      score: '{correct} von {total} richtig · {pct}%',
      lastAttempt: 'Letzter Versuch: {correct} von {total} richtig ({pct}%)',

      err_locked: 'Diese Lektion ist für Sie noch nicht freigeschaltet.',
      err_not_found: 'Diese Übung gibt es nicht mehr. Laden Sie die Seite neu.',
    },
  },
)
